import MapContainer from "@/Map/Index.vue";
import MapClusterContainer from "@/MapCluster/Index.vue";

export default [
  {
    path: "/map",
    name: "MapContainer",
    component: MapContainer,
    meta: {
      permissionRoles: ["jobs"]
    }
  },
  {
    path: "/map/cluster",
    name: "MapClusterContainer",
    component: MapClusterContainer,
    meta: {
      permissionRoles: ["jobs"]
    }
  }
];
